import React, {FC, ReactNode} from "react";
import cls from "./custom_site.module.scss"
import {IPageProps} from "../../../types/pages";
import {replaceDescr} from "../../../services/utils";
import SmartSearch from "../../shared/SmartSearch/SmartSearch";
import BuilderSection from "../../builder/BuilderDataRender";

interface IProps extends IPageProps {
    pageSlug: string,
    showWishlist: boolean,
    showCart: boolean,
}

const Content: FC<IProps> = (props) => {
    const {
        content,
        domain,
        dbName,
        selectedCurrItems,
        translationsData,
        selectedLocale,
        getBuilderData,
        showBuilderData,
        showWishlist,
        showCart,
        currencies,
        backOrderValue,
        isMobile,
        recaptchaActive,
        pageSlug
    } = props;

    const [{
        code: selectedCurrCode = "",
        symbol: selectedCurrSymbol = "",
        exchange_rate: {rate: selectedCurrRate = "1"} = {},
    } = {}] = currencies

    const builderProps = {
        getBuilderData,
        domain,
        dbName,
        translationsData,
        selectedLocale,
        currencies,
        backOrderValue,
        selectedCurrItems: {selectedCurrCode, selectedCurrRate, selectedCurrSymbol},
        isMobile,
        recaptchaActive
    }
    const showBuilderComponents:
        (id: number) => Record<"true" | "false", ReactNode> = (id) => {
        return {
            "true": <BuilderSection tab={id} {...builderProps} />,
            "false": null
        }
    }

    const {
        data: [{
            contentHeight = {},
            page_title = "",
            hasShortCode = false,
            html_content = "",
            isTable = false,
            shortCodeId = 0
        } = {}] = []
    } = content || {}

    const styles: { true: React.CSSProperties, false: React.CSSProperties } = {
        true: {
            overflowX: "auto",
            wordBreak: "break-word"
        },
        false: {
            wordBreak: "break-word"
        }
    }

    const shortCodeView = {
        true: <div>
            <SmartSearch
                rootId={shortCodeId}
                translationsData={translationsData}
                selectedCurrItems={selectedCurrItems}
                selectedLocale={selectedLocale}
                dbName={dbName}
                domain={domain}
                showWishlist={showWishlist}
                showCart={showCart}
            />
        </div>,
        false: null
    }

    return (
        <div className="block">
            <div className={`page__${pageSlug}__box`}>
                <h1
                    style={{textAlign: "center"}}
                    dangerouslySetInnerHTML={{__html: page_title}}
                />
            </div>
            {showBuilderComponents(1)[`${showBuilderData}`]}
            <div className="container">
                <div className={`${cls.document} ${hasShortCode && cls.document_with_short}`}
                     style={contentHeight}
                >
                    <div
                        className={cls.rich_text_content}
                        dangerouslySetInnerHTML={{__html: replaceDescr(html_content)}}
                        style={styles[`${isTable}`]}
                    />
                </div>
                {shortCodeView[`${hasShortCode}`]}
            </div>
            {showBuilderComponents(3)[`${showBuilderData}`]}
        </div>
    );
}

export default Content;
